import { RECOMMEND_SEARCH_WORD_TYPE } from '../../../../constants/service/app/recommendSearchWordConstants';
import { _LIST_PAGINATION_MODEL } from '../../app/models';

/**
 *  추천 검색 키워드 리스트 검색 박스 모델
 */
export const RECOMMEND_SEARCH_WORD_LIST_SEARCH_DATA_MODEL = {
  /**
   *  추천 검색 키워드 타입
   */
  recommendSearchWordType: null,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 검색 키워드 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  추천 검색 키워드 리스트 검색 옵션 모델
 */
export const RECOMMEND_SEARCH_WORD_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  추천 검색 키워드 타입
   */
  recommendSearchWordType: null,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 검색 키워드 생성일
   */
  createDate: null,
};

/**
 *  추천 검색 키워드에 연결할 아이템 리스트 필터 옵션 모델
 */
export const RECOMMEND_SEARCH_WORD_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  검색 키워드 번호
   */
  searchWordId: null,
  /**
   *  검색 단어
   */
  word: null,
};

/**
 *  추천 검색 키워드에 연결할 아이템 리스트 필터 정렬 모델
 */
export const RECOMMEND_SEARCH_WORD_ITEM_LIST_SORT_OPTION_MODEL = {
  /**
   *  검색 누적 횟수
   */
  count: 'descend',
  /**
   *  검색 키워드 생성일
   */
  createDate: null,
};

/**
 *  추천 검색 키워드 등록/복사 모델
 */
export const RECOMMEND_SEARCH_WORD_SAVE_MODEL = {
  /**
   *  추천 검색 키워드 정보
   */
  recommendSearchWordInfo: {
    /**
     *  추천 검색 키워드 타입
     */
    type: RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP,
    /**
     *  메모
     */
    memo: null,
  },
  /**
   *  추천 검색 키워드 아이템 리스트
   */
  recommendSearchWordItemList: {
    /**
     *  추천 검색 키워드에 연결할 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: RECOMMEND_SEARCH_WORD_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_SEARCH_WORD_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  선택된 추천 검색 키워드에 연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
      idList: [],
    },
  },
};
